module.exports = __webpack_public_path__ + "img/location.cda77282.jpg";